import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../AuthContext';
import './AdminTopUsers.css';

const API = process.env.REACT_APP_API_URL || 'https://api.bustisha.com/api';

export default function AdminTopUsers() {
  const { token } = useAuth();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');

  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    fetch(`${API}/admin/top-users`, { headers })
      .then((r) => r.json())
      .then((data) => setUsers(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = users.filter((u) =>
    !search || u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.username.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-top-users">
      <div className="search-bar admin-search">
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
        <input type="text" className="search-input" placeholder="Search top users..." value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      <div className="top-users-list">
        {filtered.map((u, i) => (
          <div key={u.id} className={`top-user-card ${i < 3 ? 'top-three' : ''}`}>
            <div className="top-user-rank">
              {i === 0 ? <FontAwesomeIcon icon={faTrophy} className="rank-gold" /> :
               i === 1 ? <FontAwesomeIcon icon={faTrophy} className="rank-silver" /> :
               i === 2 ? <FontAwesomeIcon icon={faTrophy} className="rank-bronze" /> :
               <span className="rank-number">#{i + 1}</span>}
            </div>
            <div className="top-user-avatar">
              {u.name.charAt(0).toUpperCase()}
            </div>
            <div className="top-user-info">
              <span className="top-user-name">{u.name}</span>
              <span className="top-user-username">@{u.username}</span>
            </div>
            <div className="top-user-stats">
              <div className="top-user-stat">
                <span className="stat-value">{Number(u.qualifying_orders || 0).toLocaleString()}</span>
                <span className="stat-label">Orders (≥1000)</span>
              </div>
              <div className="top-user-stat">
                <span className="stat-value">TSHS {Number(u.total_spent || 0).toLocaleString()}</span>
                <span className="stat-label">Total Spent</span>
              </div>
            </div>
            <div className="top-user-status">
              <span className={`status-badge ${u.status === 'active' ? 'status-completed' : 'status-cancelled'}`}>
                {u.status}
              </span>
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="top-users-empty">No top users found.</div>
        )}
      </div>
    </div>
  );
}
